import {useState} from 'react';
import {Box, FormHelperText, Grid, InputLabel, Select} from '@material-ui/core';
import {FormattedMessage, useIntl} from 'react-intl';
import messages from '@super-template/messages';
import {EditableInput, EditButton, FormFieldControl} from './';
import getTranslated from '../locale/getTranslated';
import {Controller} from "react-hook-form";
import ReactHtmlParser from 'react-html-parser';
import {isObject, remove, sortBy} from 'lodash';

export default ({array, enableEmpty, fullWidth, name, isAdmin, control, fieldOptions = {}, locale, validate, sort, translate, ...props}) => {
  const intl = useIntl();
  const [editing, setEditing] = useState(false);
  const description = getTranslated(fieldOptions.description, locale, true);
  const title = getTranslated(fieldOptions.title, locale);
  if (translate) {
    if (isObject(array[0])) array = array.map(o => ({...o, label: intl.formatMessage(o.label)}));
    else array = array.map(key => ({key, label: intl.formatMessage(messages[key])}));
  }

  if (sort) {
    const pulled = remove(array, (e) => e.key === "OTHER");
    array = [...sortBy(array, ['label']), ...pulled];
  }

  return editing ? <EditableInput fieldOptions={fieldOptions} close={() => setEditing(false)} id={name}/> :
    <Controller
      control={control} name={name} defaultValue={''} rules={isAdmin ? {} : {...validate, required: props.required}}
      render={({fieldState: {error}, field: {ref, ...field}}) =>
        <FormFieldControl fullWidth required={props.required} error={!!error}>
          <Box display="flex" justifyContent="space-between">
            <InputLabel shrink htmlFor={name}>{title}</InputLabel>
            {isAdmin && <EditButton isSmall={!fullWidth} onClick={() => setEditing(true)}/>}
          </Box>
          {description &&
          <FormHelperText component="div" className={'description'}
                          id={`${name}_description`}>{ReactHtmlParser(description)}</FormHelperText>}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={fullWidth ? 12 : 6}>
              <Select id={name} label={title} disabled={isAdmin} fullWidth native {...field} inputRef={ref} {...props}>
                <option aria-label={intl.formatMessage(messages.nothing)} disabled={!enableEmpty} value="">
                  {intl.formatMessage(messages.select)}
                </option>
                {array.map(o => <option key={title + '_' + (o.key || o)} value={o.key || o}>{o.label || o}</option>)}
              </Select>
            </Grid>
          </Grid>
          {error && <FormHelperText><FormattedMessage {...messages[error.type]}/></FormHelperText>}
        </FormFieldControl>}
    />
};
